import { IOhFollowUp } from "../models/onHandDelivery";
import {
  CHECK_BOX_MSG,
  ConditionalField,
  CreateDynamicSchema,
  FieldConfig,
  OPTION_MSG,
  REQUIRED_MSG,
  RequiredField,
} from "./formik";

// Configuration array defining validation rules
const config: FieldConfig[] = [
  RequiredField("billDetailsDescription"),
  RequiredField("onHandDetails"),
  RequiredField("didTerminalClearException", OPTION_MSG),
  RequiredField("adeCallReason"),
  RequiredField("isF9NotFlashingInAde", OPTION_MSG),
  RequiredField("hasBolInstructions", OPTION_MSG),
  
  ConditionalField(
    "followedBolInstructions",
    "hasBolInstructions",
    "Y",
    true,
    OPTION_MSG
  ),
  ConditionalField(
    "doF18NotesMatchActions",
    "hasBolInstructions",
    "Y",
    true,
    OPTION_MSG
  ),
  ConditionalField(
    "hasImageCommunication",
    "hasBolInstructions",
    "Y",
    true,
    OPTION_MSG
  ),
  RequiredField(
    "wasEveryDeliveryAttemptMade",
    CHECK_BOX_MSG,
    true,
    "string",
    true
  ),
  RequiredField("deliveryAttemptSteps", "", false),
  RequiredField(
    "wasShipperContactedWithin24hrs",
    CHECK_BOX_MSG,
    true,
    "string",
    true
  ),
  RequiredField("shipperContactSteps", "", false),
  RequiredField("isFreightOnHandDueToDamage", OPTION_MSG),

  ConditionalField("shipmentCallFor", "isFreightOnHandDueToDamage"),
  ConditionalField("productDescription", "isFreightOnHandDueToDamage"),
  ConditionalField("packageDamageDescription", "isFreightOnHandDueToDamage"),
  ConditionalField("actualProductDamageDetails", "isFreightOnHandDueToDamage"),
  ConditionalField(
    "actualProductNotDamagedDetails",
    "isFreightOnHandDueToDamage"
  ),
  ConditionalField(
    "canProductBeRecoupedForRedelivery",
    "isFreightOnHandDueToDamage"
  ),
  ConditionalField("isProductRepairable", "isFreightOnHandDueToDamage"),
  ConditionalField("hasValidDamagePictures", "isFreightOnHandDueToDamage"),
  ConditionalField("isProductGlass", "isFreightOnHandDueToDamage"),

  RequiredField(
    "ohnVerbiageCorrect",
    CHECK_BOX_MSG,
    true,
    "string",
    true
  ),
  RequiredField("wasContactFrom7823", OPTION_MSG),
  ConditionalField("stepsTakenFrom7823", "wasContactFrom7823"),
  RequiredField("wasContactFrom8511", OPTION_MSG),
  ConditionalField("stepsTakenFrom8511", "wasContactFrom8511"),
  RequiredField("googleCheck", OPTION_MSG),
  ConditionalField("googleCheckResponse", "googleCheck"),
  RequiredField("pickupScreenCheck", OPTION_MSG),
  ConditionalField("pickupScreenResponse", "pickupScreenCheck"),
  RequiredField("salesRepCheck", OPTION_MSG),
  ConditionalField("salesRepResponse", "salesRepCheck"),

  RequiredField("isShipperValueInWriting", OPTION_MSG),
  RequiredField(
    "communicationImagedByTerminal",
    CHECK_BOX_MSG,
    true,
    "string",
    true
  ),
  RequiredField(
    "f18NotesUpdatedByAll",
    CHECK_BOX_MSG,
    true,
    "string",
    true
  ),
  RequiredField("freightHasAppointment", OPTION_MSG),
  RequiredField("storageChargesApproved", OPTION_MSG),
  RequiredField("f18Note", REQUIRED_MSG, true, "string", false, 150, "Maximum 150 characters allowed"),
];
// Function to create a Yup validation schema dynamically from the config array

// Exporting the dynamically created schema
export const onHandFollowupSchema = CreateDynamicSchema(config);

export const intiOnHandFollowupFormValue: IOhFollowUp = {
  billDetailsDescription: undefined,
  onHandDetails: undefined,
  didTerminalClearException: undefined,
  adeCallReason: undefined,
  isF9NotFlashingInAde: undefined,
  hasBolInstructions: undefined,
  followedBolInstructions: undefined,
  doF18NotesMatchActions: undefined,
  hasImageCommunication: undefined,
  wasEveryDeliveryAttemptMade: undefined,
  deliveryAttemptSteps: undefined,
  wasShipperContactedWithin24hrs: undefined,
  shipperContactSteps: undefined,
  isFreightOnHandDueToDamage: undefined,
  shipmentCallFor: undefined,
  productDescription: undefined,
  packageDamageDescription: undefined,
  actualProductDamageDetails: undefined,
  actualProductNotDamagedDetails: undefined,
  canProductBeRecoupedForRedelivery: undefined,
  isProductRepairable: undefined,
  hasValidDamagePictures: undefined,
  isProductGlass: undefined,
  ohnVerbiageCorrect: undefined,
  wasContactFrom7823: undefined,
  stepsTakenFrom7823: undefined,
  wasContactFrom8511: undefined,
  stepsTakenFrom8511: undefined,
  googleCheck: undefined,
  googleCheckResponse: undefined,
  pickupScreenCheck: undefined,
  pickupScreenResponse: undefined,
  salesRepCheck: undefined,
  salesRepResponse: undefined,
  isShipperValueInWriting: undefined,
  communicationImagedByTerminal: undefined,
  f18NotesUpdatedByAll: undefined,
  freightHasAppointment: undefined,
  storageChargesApproved: undefined,
  f18Note: undefined,
};